import { localeToCurrencyCode } from '../config/localeToCurrencyCode'

const getCurrencyCodeFromLocale = (
    locale: 'fr-FR' | 'nl-NL' | 'en-US' | 'fr-FR-CSE' | string
) => {
    const currency = localeToCurrencyCode[locale]
    if (!currency)
        throw new Error(
            'currency code for locale ' + locale + ' was not defined'
        )
    return currency
}

export default getCurrencyCodeFromLocale
